export const RECORDS_PER_PAGE = 10;

export const DEFAULT_PAGINATION = {
  current: 1,
  pageSize: RECORDS_PER_PAGE,
  total: null,
};
